const JS_HOOK_QTY_INPUT = '[js-hook-quantity-input]';
/**
 * Retrieve contextual quantity selector
 * @param {jquery} el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
const getQuantitySelector = function (el) {
  return el && document.querySelector('[js-hook-set-items]') ?
    el.closest('[js-hook-product-detail]')?.querySelector(JS_HOOK_QTY_INPUT) :
    document.querySelector(JS_HOOK_QTY_INPUT);
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {HTMLElement} el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
const getQuantitySelected = function (el) {
  const { quantity } = el.dataset;
  const quantitySelectorQty = getQuantitySelector(el) ? getQuantitySelector(el).value : 1;
  return quantity || quantitySelectorQty;
};


export default getQuantitySelected;
